module.exports = __webpack_public_path__ + "./fonts/icomoon.788e8eb4a6a14f164ddb0679e337dc69.woff";